import React from 'react';
import { cn } from '../../lib/utils';

const LOGO_SRC = '/assets/axiomflow-logo.png';

interface AxiomFlowMarkProps {
  size?: number;
  className?: string;
  ariaLabel?: string;
}

export const AxiomFlowMark: React.FC<AxiomFlowMarkProps> = ({
  size = 40,
  className,
  ariaLabel = 'AxiomFlow',
}) => (
  <span
    role="img"
    aria-label={ariaLabel}
    className={cn(
      'relative inline-flex shrink-0 overflow-hidden rounded-xl border border-cyan-300/35 bg-slate-950 shadow-[0_0_18px_rgba(34,211,238,0.18)]',
      className
    )}
    style={{ width: size, height: size }}
  >
    <img
      src={LOGO_SRC}
      alt=""
      aria-hidden="true"
      className="pointer-events-none absolute max-w-none select-none"
      style={{
        width: size * 2.35,
        height: size * 2.35,
        left: '50%',
        top: '63%',
        transform: 'translate(-50%, -50%)',
        filter: 'brightness(1.28) saturate(1.12)',
      }}
    />
  </span>
);

interface AxiomFlowBrandProps {
  title?: string;
  subtitle?: string;
  size?: number;
  className?: string;
  titleClassName?: string;
  subtitleClassName?: string;
}

export const AxiomFlowBrand: React.FC<AxiomFlowBrandProps> = ({
  title = 'AxiomFlow',
  subtitle,
  size = 40,
  className,
  titleClassName,
  subtitleClassName,
}) => (
  <div className={cn('flex items-center gap-3', className)}>
    <AxiomFlowMark size={size} />
    <div className="leading-none">
      <div className={cn('font-bold tracking-tight text-white', titleClassName)}>{title}</div>
      {subtitle && (
        <div className={cn('mt-1 font-semibold uppercase tracking-[0.18em] text-slate-500', subtitleClassName)}>
          {subtitle}
        </div>
      )}
    </div>
  </div>
);

export const AxiomFlowFullLogo: React.FC<{ className?: string; alt?: string }> = ({
  className,
  alt = 'AxiomFlow',
}) => <img src={LOGO_SRC} alt={alt} className={cn('block h-auto max-w-full select-none', className)} />;
